export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'saveStatus',
    align: 'center',
    width: 100,
    title: '导入状态',
    slots: {default: 'status'},
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'orderSortInfo',
    width: 100,
    align: 'center',
    title: '订单序号',
  },
  {
    field: 'custName',
    title: '客户名称(简称)',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'orgName',
    title: '负责机构',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'orderTypeName',
    title: '订单类型',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'bizTypeName',
    title: '业务类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'transportModeName',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'orderDate',
    title: '客户托运日期',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'bizBillNo',
    title: 'ERP/WMS单号',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'orderSoNo',
    title: '销售订单号',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'wayBillNo',
    title: '运单单号',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'vehicleModelName',
    title: '车型需求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'vehicleLengthName',
    title: '车长需求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'vehicleLoad',
    title: '载重需求（吨）',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'vehicleVolume',
    title: '载方需求（立方米）',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'receiveSign',
    title: '送货签到要求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'receiveBill',
    title: '送货单证要求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'pickupSign',
    title: '提货签到要求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'pickupBill',
    title: '提货单证要求',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'isBack',
    title: '是否返程',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'isMatchingContract',
    title: '合同订单必须匹配合同',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'pickDatetimeBegin',
    title: '预计提货开始时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'pickDatetimeEnd',
    title: '预计提货截止时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'receiveDatetimeBegin',
    title: '预计送达开始时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'receiveDatetimeEnd',
    title: '预计送达截止时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    headerAlign: 'center',
    align: 'center',
    title: '发货方',
    children: [
      {
        field: 'pickData.orderPointName',
        title: '发货方',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.placeOfOrigin',
        title: '始发地',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.linePointAddress',
        title: '详细地址',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.contactName',
        title: '联系人',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.contactMobile',
        title: '手机号',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.contactPhone',
        title: '固定电话',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.contactEmail',
        title: '联系人Email',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.electronicFence',
        title: '发货电子围栏半径(米)',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.orderPickType',
        title: '是否需要装货',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'pickData.remark',
        title: '备注',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
    ],
  },
  {
    headerAlign: 'center',
    align: 'center',
    title: '收货方',
    children: [
      {
        field: 'receivingData.orderPointName',
        title: '收货方',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.destination',
        title: '目的地',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.linePointAddress',
        title: '详细地址',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.contactName',
        title: '联系人',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.contactMobile',
        title: '手机号',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.contactPhone',
        title: '固定电话',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.contactEmail',
        title: '联系人Email',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.electronicFence',
        title: '收货电子围栏半径(米)',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.orderPickType',
        title: '是否需要装货',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'receivingData.remark',
        title: '备注',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
    ],
  },
  {
    headerAlign: 'center',
    align: 'center',
    title: '货物详情',
    children: [
      {
        field: 'goodsImport[0].orderSort',
        title: '关联订单序号',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsName',
        title: '货物名称',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsNo',
        title: '货物代码',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsType',
        title: '货物类型',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].packageType',
        title: '包装类型',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsQty',
        title: '包装件数',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsWeight',
        title: '预计重量kg',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsVolume',
        title: '预计体积m³',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsValue',
        title: '货值',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].factWeight',
        title: '实际重量kg',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].factVolume',
        title: '实际体积m³',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
      {
        field: 'goodsImport[0].goodsRemarks',
        title: '备注说明',
        headerAlign: 'center',
        align: 'center',
        width: 160,
      },
    ],
  },
]
